<template>
  <span class="status-badge" :class="`status-badge--${tone}`">
    <q-icon :name="icon" aria-hidden="true" />
    <span>{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: 'info' },
    tone: {
      type: String,
      default: 'neutral',
      validator: (value) => ['neutral', 'success', 'warning', 'danger', 'info'].includes(value)
    }
  }
}
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--sid-space-1);
  padding: var(--sid-space-1) var(--sid-space-2);
  border-radius: var(--sid-radius-pill);
  background: var(--sid-color-surface-subtle);
  color: var(--sid-color-text-secondary);
  font-size: var(--sid-font-size-label);
  font-weight: var(--sid-font-weight-medium);
  line-height: var(--sid-line-height-label);
  white-space: nowrap;
}

.status-badge--success { background: var(--sid-color-success-surface); color: var(--sid-color-success); }
.status-badge--warning { background: var(--sid-color-warning-surface); color: var(--sid-color-warning); }
.status-badge--danger { background: var(--sid-color-danger-surface); color: var(--sid-color-danger); }
.status-badge--info { background: var(--sid-color-info-surface); color: var(--sid-color-info); }
</style>
